export enum ValidationType {
  TRADES = 'trades',
  DEBTS = 'debts',
}
